import { api } from './api'
import type { BatchDocument, BatchSummary, BatchUploadResponse } from '../types/batchDocument'
import type { PatientFile } from '../types/patientFile'

export const batchDocumentService = {
  listBatches: async (): Promise<BatchSummary[]> => {
    const response = await api.get<BatchSummary[]>('/batch-documents')
    return response.data
  },

  listBatchFiles: async (batchId: string): Promise<BatchDocument[]> => {
    const response = await api.get<BatchDocument[]>('/batch-documents', {
      params: { batchId },
    })
    return response.data
  },

  getByFileId: async (fileId: string): Promise<BatchDocument> => {
    const response = await api.get<BatchDocument>(`/batch-documents/${fileId}`)
    return response.data
  },

  uploadBatch: async (files: File[]): Promise<BatchUploadResponse> => {
    const formData = new FormData()
    for (const file of files) {
      formData.append('file', file)
    }
    const response = await api.post<BatchUploadResponse>('/batch-documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },

  extractText: async (fileId: string): Promise<BatchDocument> => {
    const response = await api.post<BatchDocument>(`/batch-documents/${fileId}/extract`)
    return response.data
  },

  acceptMatch: async (fileId: string, patientId: string): Promise<PatientFile> => {
    const response = await api.post<PatientFile>(`/batch-documents/${fileId}/accept-match`, {
      patientId,
    })
    return response.data
  },

  linkToPatient: async (fileId: string, patientId: string): Promise<PatientFile> => {
    const response = await api.post<PatientFile>(`/batch-documents/${fileId}/link`, {
      patientId,
    })
    return response.data
  },

  getPreviewUrl: async (fileId: string): Promise<{ url: string }> => {
    const response = await api.get<{ url: string }>(`/batch-documents/${fileId}/preview`)
    return response.data
  },

  deleteFile: async (fileId: string): Promise<void> => {
    await api.delete(`/batch-documents/${fileId}`)
  },
}
